import axios from 'axios';
const GET_GROUP = '/reports/context';

export const getGroups = () => axios.get(`${GET_GROUP}`);


